// Stable per-player colors, assigned by JOIN ORDER (index in room.players).
// The players array is broadcast identically to host + all players, so every
// screen derives the same color for the same player — consistent all game long.
export const PLAYER_COLORS = [
  "#4A90D9", // blue
  "#E8564F", // red
  "#2BB3A3", // teal
  "#C9962F", // gold
  "#7C5CBF", // purple
  "#E4739B", // pink
  "#E28F41", // orange
  "#5FB65A", // green
];

export function playerColorIndex(players, playerId) {
  const idx = (players || []).findIndex((p) => p.id === playerId);
  return idx < 0 ? 0 : idx % PLAYER_COLORS.length;
}

export function playerColor(players, playerId) {
  return PLAYER_COLORS[playerColorIndex(players, playerId)];
}
